<ng-template #content let-c="close" let-d="dismiss">
  <ng-content></ng-content>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/main/influencer-home/message-popup/message-popup.component.html